import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { hideCart, addCart, getRecommendations } from './actions';
import { trackNow } from 'shared/models/analytic';
import CartList from './list';
import FreeShippingMeter from './freeShippingMeter';
import QuickView from '../quickView';
import View from 'components/ui/view';
import Recommendations from '../recommendation';
import CardLogoList from 'components/payment/logoList';
import Experiment from 'components/experiment';
import Variant from 'components/experiment/variant';
import Text from 'components/ui/text';

let CartPreview = class CartPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = { quickViewProduct: null };
    this.hideCart = this.hideCart.bind(this);
    this.checkout = this.checkout.bind(this);
    this.openQuickView = this.openQuickView.bind(this);
    this.closeQuickView = this.closeQuickView.bind(this);
    this.addToCart = this.addToCart.bind(this);
  }

  componentDidMount() {
    this.props.getRecommendations(this.props.skus);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.skus.join() !== nextProps.skus.join()) {
      this.props.getRecommendations(nextProps.skus);
    }
  }

  hideCart() {
    this.props.hideCart();
  }

  checkout() {
    trackNow('Cart Checkout Action Clicked');
    return (window.location = '/checkout');
  }

  openQuickView(product) {
    this.setState({ quickViewProduct: product });
  }

  closeQuickView() {
    this.setState({ quickViewProduct: null });
  }

  addToCart(product, qty) {
    return this.props.addCart(product, qty);
  }

  render() {
    const subtotal = this.props.products
      .concat(this.props.engravings)
      .filter(p => p.subtotal)
      .reduce((sum, p) => sum + p.subtotal, 0);
    const originalSubtotal = this.props.products
      .concat(this.props.engravings)
      .filter(p => p.originalSubtotal || p.subtotal)
      .reduce((sum, p) => sum + (p.originalSubtotal || p.subtotal), 0);
    const disabled = this.props.loading || !subtotal;
    const hasRecommendations =
      this.props.loadingRecommendations || !!this.props.recommendations.length;
    const hasShippingMeter = !!subtotal && this.props.shipping;
    const previewClassName =
      'cart-preview__list' +
      (hasRecommendations ? ' cart-preview__list--has-recommendations' : '') +
      (hasShippingMeter ? ' cart-preview__list--has-shipping-meter' : '');
    const carouselSettings = {
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 5, slidesToScroll: 5 } },
        { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 4 } }
      ]
    };

    const showDiscount = originalSubtotal > subtotal;

    const experiments = this.props.experiments || {};
    const listContainerClass =
      'cart-preview__list-container' +
      (showDiscount ? ' cart-preview__list-container--discount' : '') +
      (experiments['Cart Payment Logos'] === 'Show Logos'
        ? ' cart-preview__list-container--logos'
        : '');
    const footerClass =
      'cart-preview__footer' +
      (showDiscount ? ' cart-preview__footer--discount' : '');
    experiments['Cart Payment Logos'] === 'Show Logos'
      ? ' cart-preview__footer--logos'
      : '';

    return (
      <div className="cart-preview">
        <div className="cart-preview__header">
          <button
            type="button"
            className="btn--inline right cart-preview__cancel"
            onClick={this.hideCart}
          >
            ×
          </button>
          <h2 className="cart-preview__heading">Your Cart</h2>
        </div>

        <div className={listContainerClass}>
          {hasShippingMeter && (
            <Fragment>
              <FreeShippingMeter subtotal={subtotal} />
              <View padding={{ sides: 'sm' }}>
                <hr className="light" />
              </View>
            </Fragment>
          )}

          <CartList
            className={previewClassName}
            onClick={this.openQuickView}
            subtotal={subtotal}
          />

          {hasRecommendations && (
            <div className="cart-preview__recommendations">
              <Recommendations
                thumbnail
                title={"Don't Forget to Add"}
                list={this.props.recommendations}
                onClick={this.openQuickView}
                {...carouselSettings}
              />
            </div>
          )}
        </div>

        <div className={footerClass}>
          <div className="cart-preview__subtotal">
            <div className="right">${subtotal.toFixed(2)}</div>
            <div>Subtotal</div>
          </div>

          {showDiscount && (
            <View padding={{ sides: 'xs' }}>
              <Text success weight="med" className="text-right">
                You saved ${(originalSubtotal - subtotal).toFixed(2)}
              </Text>
            </View>
          )}

          <p className="text-center text-emphasized">
            <small>
              Shipping, taxes, and discounts calculated at checkout.
            </small>
          </p>

          <Experiment name="Cart Payment Logos" defaultVariant="Null">
            <Variant name="Null">{''}</Variant>
            <Variant name="Show Logos">
              <View margin="sm" className="text-center">
                <CardLogoList />
              </View>
            </Variant>
          </Experiment>

          <button
            className={
              'btn-primary btn--full-width' +
              (this.props.products.length ? ' green' : '')
            }
            disabled={disabled}
            onClick={this.checkout}
          >
            Checkout
          </button>
        </div>

        <QuickView
          product={this.state.quickViewProduct}
          changeProduct={this.openQuickView}
          addToCart={this.addToCart}
          close={this.closeQuickView}
        />
      </div>
    );
  }
};

CartPreview = connect(
  state => ({
    show: state.cart.show,
    loading: state.cart.loading,
    products: state.cart.products,
    engravings: state.cart.engravings,
    skus: state.cart.products.map(p => p.sku_id),
    loadingRecommendations: state.cart.loadingRecommendations,
    recommendations: state.cart.recommendations,
    shipping: state.address.shipping,
    experiments: state.app.experiments
  }),
  { hideCart, addCart, getRecommendations }
)(CartPreview);

export default CartPreview;



// WEBPACK FOOTER //
// ./shared/components/cart/preview.js